module.exports = __webpack_public_path__ + "static/media/AI_15.a4a168db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_15.png
// module id = 130
// module chunks = 0